<template>
  <q-dialog
    v-model="shown"
    style="max-width: 80vw;"
  >
    <q-card style="width: 80vw; max-width: 80vw;">
      <q-card-section>
        <q-tabs
          v-model="tab"
          dense
        >
          <q-tab
            name="memory"
            label="Memory Statistics"
          />
          <q-tab
            name="screen"
            label="Screen Share"
          />
          <q-tab
            name="console"
            label="Console Stream"
          />
        </q-tabs>
        <q-tab-panels v-model="tab">
          <q-tab-panel name="memory">
            <report
              v-if="registerClient"
              class="col"
              :system-report="SYSTEM_REPORTS.REGISTER_CLIENT_MEMORY_REPORT"
              :options="{ register_client_id: registerClient.id }"
            />
          </q-tab-panel>

          <q-tab-panel name="screen">
            <share-screen
              :register-client="registerClient"
            />
          </q-tab-panel>
          <q-tab-panel name="console">
            <console-stream
              :register-client="registerClient"
            />
          </q-tab-panel>
        </q-tab-panels>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { SYSTEM_REPORTS } from 'src/models/report/Report'
import ConsoleStream from 'src/modules/admin/register-station/components/ConsoleStream'
import ShareScreen from 'src/modules/admin/register-station/components/ShareScreen'
import Report from 'src/modules/admin/report/Report'

export default {
  name: 'RegisterClientDialog',
  configuration: ['registerTypes', 'currentCircuit', 'currentSite'],
  context: ['currentUser'],
  components: {
    Report,
    ShareScreen,
    ConsoleStream
  },
  data () {
    return {
      shown: false,
      registerClient: null,
      tab: 'memory'
    }
  },
  created () {
    _.extend(this, { SYSTEM_REPORTS })
  },
  methods: {
    show (registerClient) {
      this.registerClient = registerClient
      this.shown = true
    }
  }
}

</script>
